import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExchange = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.3125 11.125C13.4496 11.125 12.75 11.8246 12.75 12.6875C12.75 13.5504 13.4496 14.25 14.3125 14.25C15.1754 14.25 15.875 13.5504 15.875 12.6875C15.875 11.8246 15.1754 11.125 14.3125 11.125ZM11.5 12.6875C11.5 11.1342 12.7592 9.875 14.3125 9.875C15.8658 9.875 17.125 11.1342 17.125 12.6875C17.125 14.2408 15.8658 15.5 14.3125 15.5C12.7592 15.5 11.5 14.2408 11.5 12.6875Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.80806 1.30806C10.0521 1.06398 10.4479 1.06398 10.6919 1.30806L13.6529 4.269C14.4739 5.09081 14.9359 6.20471 14.9375 7.36634V10.5C14.9375 10.8452 14.6577 11.125 14.3125 11.125C13.9673 11.125 13.6875 10.8452 13.6875 10.5V7.36761C13.6863 6.53685 13.3559 5.7404 12.7688 5.15265L9.80806 2.19194C9.56398 1.94786 9.56398 1.55214 9.80806 1.30806Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.625 1.75C9.625 1.40482 9.90482 1.125 10.25 1.125H13.375C13.7202 1.125 14 1.40482 14 1.75C14 2.09518 13.7202 2.375 13.375 2.375H10.875V4.875C10.875 5.22018 10.5952 5.5 10.25 5.5C9.90482 5.5 9.625 5.22018 9.625 4.875V1.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.6875 1.75C2.82456 1.75 2.125 2.44956 2.125 3.3125C2.125 4.17545 2.82456 4.875 3.6875 4.875C4.55045 4.875 5.25 4.17545 5.25 3.3125C5.25 2.44956 4.55045 1.75 3.6875 1.75ZM0.875 3.3125C0.875 1.7592 2.1342 0.5 3.6875 0.5C5.2408 0.5 6.5 1.7592 6.5 3.3125C6.5 4.8658 5.2408 6.125 3.6875 6.125C2.1342 6.125 0.875 4.8658 0.875 3.3125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.6875 4.875C4.03268 4.875 4.3125 5.15482 4.3125 5.5V8.63236C4.31373 9.46303 4.64399 10.2594 5.231 10.8471L8.19194 13.8081C8.43602 14.0521 8.43602 14.4479 8.19194 14.6919C7.94786 14.936 7.55214 14.936 7.30806 14.6919L4.34712 11.731C3.52614 10.9092 3.06407 9.79529 3.0625 8.63366L3.0625 5.5C3.0625 5.15482 3.34232 4.875 3.6875 4.875Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.75 10.5C8.09518 10.5 8.375 10.7798 8.375 11.125V14.25C8.375 14.5952 8.09518 14.875 7.75 14.875H4.625C4.27982 14.875 4 14.5952 4 14.25C4 13.9048 4.27982 13.625 4.625 13.625H7.125V11.125C7.125 10.7798 7.40482 10.5 7.75 10.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgExchange;
